// src/shared/ui/GlobalToaster.jsx
import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { uiBus } from 'shared/api/uiBus';

export function GlobalToaster() {
  const [open, setOpen] = React.useState(false);
  const [msg, setMsg] = React.useState('');
  const [severity, setSeverity] = React.useState('error');

  React.useEffect(() => {
    return uiBus.on('toast', ({ type, message }) => {
      setSeverity(type || 'error');
      setMsg(message || 'Bir hata oluştu.');

      // ✅ her seferinde yeniden aç (garanti)
      setOpen(false);
      requestAnimationFrame(() => setOpen(true));
    });
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={3500}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1000 }} // ✅ modal üstüne çıksın
    >
      <Alert
        onClose={() => setOpen(false)}
        severity={severity}
        variant="filled"
        sx={{ borderRadius: 2, boxShadow: 6 }}
      >
        {msg}
      </Alert>
    </Snackbar>
  );
}
